export type WorkspaceTourStatus = 'completed' | 'skipped';

export type WorkspaceTourRecord = {
  version: 1;
  status: WorkspaceTourStatus;
  completedAt: string;
};

const TOUR_VERSION = 1 as const;

function storageKey(userId: string): string {
  return `dc_workspace_tour_v${TOUR_VERSION}:${userId}`;
}

export function readWorkspaceTourRecord(userId: string | null | undefined): WorkspaceTourRecord | null {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<WorkspaceTourRecord>;
    if (parsed.version !== TOUR_VERSION) return null;
    if (parsed.status !== 'completed' && parsed.status !== 'skipped') return null;
    return {
      version: TOUR_VERSION,
      status: parsed.status,
      completedAt: typeof parsed.completedAt === 'string' ? parsed.completedAt : new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function hasFinishedWorkspaceTour(userId: string | null | undefined): boolean {
  return Boolean(readWorkspaceTourRecord(userId));
}

export function markWorkspaceTourFinished(userId: string, status: WorkspaceTourStatus): void {
  const record: WorkspaceTourRecord = {
    version: TOUR_VERSION,
    status,
    completedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(record));
  } catch {
    /* ignore quota / private mode */
  }
}
